((window, document, undefined) => {
  'use strict';

  const reportArticle = document.querySelector('.vodl-report-article'),
    articleTitle = document.querySelector('.vodl-region-article__title');

  let rmsso = false,
    reportButton = false,
    reportButtonSubmit = false,
    reportModal = false,
    reportCancelButton = false,
    title = '',
    premiumContent = false;

  const handleReportClick = (e) => {
    e = e || false;
    if (e) {
      e.preventDefault();
    }

    reportModal.style.display = 'flex';
  };

  const handleReportCancelClick = (e) => {
    e = e || false;
    if (e) {
      e.preventDefault();
    }

    reportModal.style.display = 'none';
  };

  const showNotification = (header, title, text) => {
    const deferred = $.Deferred(),
      notificationModal = document.querySelector('.vodl-notification--modal');

    let notification = false,
      notificationBody = false,
      notificationHeader = false,
      notificationTitle = false,
      notificationText = false;

    header = header || '';
    title = title || '';
    text = text || '';

    if (null === notificationModal) {
      deferred.reject();
      return deferred.promise();
    }

    notificationHeader = notificationModal.querySelector('.vodl-notification__header-text');
    notificationTitle = notificationModal.querySelector('.vodl-notification__title');
    notificationText = notificationModal.querySelector('.vodl-notification__text');

    notificationHeader.innerHTML = header;
    notificationTitle.innerHTML = title;
    notificationText.innerHTML = text;

    if (premiumContent) {
      notification = notificationModal.querySelector('.vodl-notification');
      notificationBody = notificationModal.querySelector('.vodl-notification__body');
      let notificationButton = notificationModal.querySelector('.vodl-notification__button');

      if (!notificationButton) {
        notificationButton = document.createElement('div');
        notificationButton.innerHTML = '<div class="vodl-notification__button"><button class="vodl-button vodl-button--red" type="button"><span class="vodl-button__label">OK</span></button></div>';
        notificationBody.append(notificationButton);
      }

      notification.classList.add('vodl-notification--vplus');
    }

    notificationModal.style.display = 'flex';
    notificationModal.querySelector('.vodl-notification__header').classList.add('vodl-notification__header--show');
    deferred.resolve();

    return deferred.promise();
  };

  const handleReportSubmit = () => {
    const reportReason = reportModal.querySelector('.vodl-select-report__current').getAttribute('data-report-slug') || '',
      reportTextArea = reportModal.querySelector('.vodl-comment-report__input-text'),
      reportText = reportTextArea.value || '',
      reportError = reportModal.querySelector('.vodl-comment-report__error'),
      postID = reportArticle.getAttribute('data-id'),
      username = document.querySelector('.vodl-login-label__username a').innerHTML;

    if ('' === reportReason){
      reportError.innerHTML = 'Bitte wähle einen Grund für Deine Meldung.';
      return false;
    }

    const data = {
      reason: reportReason,
      reporttext: reportText,
      post_id: postID,
      username
    };

    $.ajax({
      url: '/api/nnp/report_article',
      type: 'get',
      dataType: 'json',
      data: data
    }).then((result) => {
      showNotification('Vielen Dank!', false, 'Wir prüfen den gemeldeten Artikel').always(() => {
        reportModal.style.display = 'none';
        reportTextArea.value = '';
        reportError.innerHTML = '';
        trackGA();
        trackOEWA();
      });
    });
  };

  const init = () => {
    if(null !== reportArticle) {
      reportButton = reportArticle.querySelector('.vodl-report-article__button');
      reportButtonSubmit = reportArticle.querySelector('.vodl-comment-report__submit');
      reportModal = reportArticle.querySelector('.vodl-comment-report--modal');
      reportCancelButton = reportArticle.querySelector('.vodl-comment-report__close-form');

      reportButton.addEventListener('click', handleReportClick);
      reportButtonSubmit.addEventListener('click', handleReportSubmit);
      reportCancelButton.addEventListener('click', handleReportCancelClick);
      reportArticle.style.display = 'block';

      premiumContent = document.querySelector('.vodl-region-article__premium-content');

      if (null !== articleTitle) {
        title = articleTitle.innerHTML.replace(/[^a-zA-Z0-9]/g, '_');
      }
    }
  };

  $(document).ready(() => {
    window.RussMedia = window.RussMedia || {};
    rmsso = window.RussMedia.SSO || false;
    rmsso.isLoggedInAsync().then(
      function() {
        init();
      },
      function() {
        //nothing to do here
      }
    );
  });

  const trackGA = () => {
    if ( typeof dataLayer !== 'undefined' && typeof gtm_tracking_enable !== 'undefined' && true === gtm_tracking_enable ) {
      const eventData = {
        event: 'genericEvent',
        eventCategory: 'ReportArticle',
        eventAction: title,
      };

      dataLayer.push(eventData);

      document.dispatchEvent(
        new CustomEvent('hansrmdtevent', { detail: eventData })
      );
    }
  };

  const trackOEWA = () => {
    if (typeof oewa_data === 'undefined') {
      return;
    }

    const modOEWA = oewa_data.cp,
      agency = modOEWA.substring(modOEWA.lastIndexOf('/') + 1),
      elements = modOEWA.split('/');

    if (modOEWA.includes('Homepage')) {
      elements[1] = 'Nachrichten';
      elements[2] = 'LokaleNachrichten';
    }

    let userAgent = navigator.userAgent;
    let device = '';
    if (/android/i.test(userAgent)) {
      device = 'Android';
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      device = 'iOS';
    }

    if (device === 'Android' || device === 'iOS'){
      oewa_data['cp'] =
          elements[0] +
          '/' +
          elements[1] +
          '/' +
          elements[2] +
          '/moewa/reportarticle/' +
          title +
          '/' +
          agency;
    } else {
      oewa_data['cp'] =
          elements[0] +
          '/' +
          elements[1] +
          '/' +
          elements[2] +
          '/' + title +
          '/' +
          agency;
    }

    if (typeof window.IOMm !== 'undefined') {
      window.IOMm('pageview', { cp: oewa_data['cp'] });
    }
  };

})(window, document);
